import Modal, { ModalProps } from "components/blocks/Modal";
import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import Dropdown from "components/blocks/Dropdown";
import { ProgramsService } from "services/programs";
import { RejectionReasonResult } from "services/programs/models/ProgramTypes";

const GenericActionsModal: React.FC<
  ModalProps & {
    onSubmit: (notes: string, action: string, rejectionReasonId?: number) => Promise<void>;
    isSubmitting: boolean;
    msg: string;
    action: string;
    programId?: number;
  }
> = (props) => {
  const { isOpen, onClose, onSubmit, isSubmitting, msg, programId } = props;
  const { t } = useTranslation(["Orders", "Common"]);
  const [notes, setNotes] = useState("");
  const [rejectionReasonId, setRejectionReasonId] = useState<number | undefined>(undefined);
  const [rejectionReasons, setRejectionReasons] = useState<RejectionReasonResult[]>([]);
  const [isLoadingReasons, setIsLoadingReasons] = useState(false);

  const onCancel = () => {
    onClose?.();
  };

  const isRejectAction = props.action === "RejectOrder";

  useEffect(() => {
    const fetchRejectionReasons = async () => {
      if (isRejectAction && programId && isOpen) {
        setIsLoadingReasons(true);
        try {
          const response = await ProgramsService.getRejectionReasonsByProgramId(programId);
          console.log("Rejection reasons response:", response);
          if (response?.data && Array.isArray(response.data)) {
            setRejectionReasons(response.data);
            console.log("Rejection reasons loaded:", response.data);
          }
        } catch (error) {
          console.error("Error fetching rejection reasons:", error);
        } finally {
          setIsLoadingReasons(false);
        }
      }
    };

    fetchRejectionReasons();
  }, [isRejectAction, programId, isOpen]);

  useEffect(() => {
    if (!isOpen) {
      setNotes("");
      setRejectionReasonId(undefined);
      setRejectionReasons([]);
    }
  }, [isOpen]);

  useEffect(() => {
    console.log("GenericActionsModal - action:", props.action);
    console.log("GenericActionsModal - isRejectAction:", isRejectAction);
    console.log("GenericActionsModal - programId:", programId);
    console.log("GenericActionsModal - rejectionReasons:", rejectionReasons);
  }, [props.action, isRejectAction, programId, rejectionReasons]);

  return (
    <Modal
      containerClassName="bg-white pb-2"
      isOpen={isOpen}
      onClose={onClose}
      title={msg}
      withHeaderBorder
      size="lg"
      titleClassName="fs-6 text-dark"
      bodyMargin="py-3"
    >
      {isRejectAction && (
        <div className="mb-3">
          <label className="form-label">{t("Common:rejectionReason")}</label>
          {isLoadingReasons ? (
            <div className="text-center py-2">
              <div className="custom-loader"></div>
            </div>
          ) : rejectionReasons.length > 0 ? (
            <Dropdown
              useReactSelect
              data={rejectionReasons.map((reason) => ({
                id: reason.id,
                value: reason.displayName,
              }))}
              value={rejectionReasonId}
              onChange={(selectedId) => {
                console.log("Selected rejection reason ID:", selectedId);
                setRejectionReasonId(Number(selectedId));
              }}
              noSelectionPlaceholder={t("Common:selectRejectionReason")}
            />
          ) : (
            <div className="text-muted">{t("Common:noRejectionReasonsAvailable")}</div>
          )}
        </div>
      )}

      <label className="form-label mt-2">{t("Common:notes")}</label>
      <textarea
        className={`form-control`}
        rows={5}
        placeholder={t("Common:notes")}
        onChange={(e) => setNotes(e.target.value)}
        style={{ resize: "none" }}
      />

      <div className="divider mt-3"></div>

      <div className="d-flex justify-content-center gap-2 w-100">
        <button type="button" className="btn text-dark rounded-3 p-10-32P" onClick={onCancel}>
          {t("Common:cancel")}
        </button>
        <button
          type="button"
          className="btn btn-primary rounded-3 p-10-32P"
          disabled={!notes.length || isSubmitting || (isRejectAction && !rejectionReasonId)}
          onClick={async () => {
            if (!notes.length) return;
            if (isRejectAction && !rejectionReasonId) return;

            await onSubmit(notes, props.action, rejectionReasonId);
          }}
        >
          {!isSubmitting ? msg : <div className="custom-loader"></div>}
        </button>
      </div>
    </Modal>
  );
};
export default GenericActionsModal;
